import {
  InteractionByMediaType,
  InteractionsByYear,
  InteractionsByTags,
} from "../types/dashboard/Dashboard";
import { getApi } from "./helpers/apiMethods";

export interface GetDashboardDataResponse {
  interactionByType: InteractionByMediaType[];
  interactionsByYear: InteractionsByYear;
  interactionTotal: number;
  interactionTotalWithoutMedia: number;
  countInteractionsExpiring: number;
  countLegalHold: number;
  interactionsByTags: InteractionsByTags[];
}

export const getDashboard = async (
  customerId: string,
  timeZone?: string
): Promise<GetDashboardDataResponse | undefined> => {
  const response = await getApi<GetDashboardDataResponse>(
    `/v1/customers/${customerId}/dashboard`,
    { params: { timeZone: timeZone } }
  );
  return response.data;
};
